import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HelpersService } from '../../services/helpers.service';
import { GlobalModalService } from '../../services/global-modal.service';

declare global {
  interface Window {
    TAIlor?: {
      toggleOpen: (state: boolean) => void;
      reloadWithId: (id: string) => void;
    };
  }
}

export interface buttonItem {
  buttonType?: string;
  buttonLabel: string;
  buttonUrl: string;
  openInNewTab: boolean;
  buttonIcon: string;
  interstitial?: boolean;
  interstitialLong?: boolean;
  interstitialSp?: boolean;
  interstitialLongSp?: boolean;
  videoAdam?:boolean;
  videoAmanda?:boolean;
  eventEmit?: boolean;
}

@Component({
  selector: '[global-button]',
  imports: [
    CommonModule
  ],
  templateUrl: './global-button.component.html',
  styleUrl: './global-button.component.scss'
})
export class GlobalButtonComponent implements OnInit {

  @Input()
  buttonData: buttonItem = {
    buttonLabel: '',
    buttonUrl: '',
    openInNewTab: false,
    buttonIcon: '',
    interstitial: false,
    interstitialLong: false,
    eventEmit: false
  }

  @Output() onButtonClick = new EventEmitter<boolean>();

  constructor(
    private helpersService: HelpersService,
    private globalModalService: GlobalModalService
  ) { }

  ngOnInit(): void {

  }

  onClick(e: Event) {
    if (this.buttonData.interstitial || this.buttonData.interstitialLong || this.buttonData.interstitialSp || this.buttonData.interstitialLongSp || this.buttonData.eventEmit) e.preventDefault();
    if (this.buttonData.interstitial) this.globalModalService.openModal('interstitial', this.buttonData.buttonUrl);
    if (this.buttonData.interstitialLong) this.globalModalService.openModal('interstitialLong', this.buttonData.buttonUrl);
    if (this.buttonData.interstitialSp) this.globalModalService.openModal('interstitialSp', this.buttonData.buttonUrl);
    if (this.buttonData.interstitialLongSp) this.globalModalService.openModal('interstitialLongSp', this.buttonData.buttonUrl);
    if (this.buttonData.videoAdam) {
      e.preventDefault();
      this.globalModalService.openModal('videoAdam');
    }
    if (this.buttonData.videoAmanda) {
      e.preventDefault();
      this.globalModalService.openModal('videoAmanda');
    }
    if (this.buttonData.buttonLabel === 'Chat with a counselor') {
      if (!this.helpersService.validatePlatform) return;
      e.preventDefault();
      if (window.TAIlor) {
        window.TAIlor.toggleOpen(true);
      }
    }
    if (this.buttonData.eventEmit) this.onButtonClick.emit(true);
  }

}
